const LoadingActionTypes = {
  LOADING_START: 'LOADING_START',
  LOADING_END: 'LOADING_END',
}

export default LoadingActionTypes
